"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getNetworkType;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.regexp.exec.js");

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _uaDetect3 = _interopRequireDefault(require("@baidu/mvideo-tool/lib/uaDetect"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _bdmedialiveScheme = _interopRequireDefault(require("@baidu/bdmedialive-scheme"));

var _config = require("./config");

var NET_TYPE = {
  'ALL': 'all',
  'WIFI': 'wifi',
  'FOURG': '4g'
};
/**
 * 获取网络状态
 */

function getNetworkType() {
  return _getNetworkType.apply(this, arguments);
}

function _getNetworkType() {
  _getNetworkType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _context;

    var _uaDetect, isWeChat, nettype, netMatch;

    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _uaDetect = (0, _uaDetect3.default)(), isWeChat = _uaDetect.isWeChat;

            if (!(0, _includes.default)(_context = _config.USER_AGENT.toLowerCase()).call(_context, 'medialiveversion')) {
              _context2.next = 12;
              break;
            }

            if (!_bdmedialiveScheme.default.canIUse('common.getNetworkInfo')) {
              _context2.next = 9;
              break;
            }

            _context2.next = 5;
            return _bdmedialiveScheme.default.common.getNetworkInfo({
              timeout: 600
            }).then(function (res) {
              var _res$data;

              var nettype = Number(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.networkType) || 'unknown';

              if (nettype === 1) {
                nettype = 'wifi';
              } else if (nettype === 2) {
                var _res$data2;

                nettype = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.mobileType;
              }

              return nettype;
            }).catch(function (err) {
              var _window, _window$console;

              (_window = window) === null || _window === void 0 ? void 0 : (_window$console = _window.console) === null || _window$console === void 0 ? void 0 : _window$console.log(err);
            });

          case 5:
            nettype = _context2.sent;
            return _context2.abrupt("return", nettype);

          case 9:
            return _context2.abrupt("return", 'unknown');

          case 10:
            _context2.next = 17;
            break;

          case 12:
            if (!isWeChat) {
              _context2.next = 17;
              break;
            }

            // 从ua获取网络类型
            netMatch = /NetType\/([a-zA-Z0-9_]*\s)/.exec(navigator.userAgent);

            if (!(netMatch && netMatch[1])) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", netMatch[1].toLowerCase() === NET_TYPE.WIFI ? NET_TYPE.WIFI : NET_TYPE.FOURG);

          case 16:
            return _context2.abrupt("return", NET_TYPE.FOURG);

          case 17:
            return _context2.abrupt("return", NET_TYPE.ALL);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _getNetworkType.apply(this, arguments);
}